<div class="d-flex justify-content-end mb-3">
  <button class="btn btn-sm btn-secondary" type="button" (click)="refresh()" [disabled]="isLoading">
    <i class="fa fa-refresh"></i> Refresh
  </button>
</div>

@if (isLoading) {
  <div class="card">
    <div class="card-body text-center text-muted py-4">
      <i class="fa fa-spinner fa-spin"></i> Loading...
    </div>
  </div>
} @else if (isLoaded) {
  <div class="card">
    <div class="card-header">
      <i class="fa fa-line-chart"></i> Credits sources - Last 7 days
    </div>
    <div class="card-body">
      @if (transactionsChartData.labels?.length) {
        <div class="row g-2 mb-3">
          @for (def of series; track def.key) {
            <div class="col-6 col-md-2">
              <div class="card text-white text-center mb-0" [style.background-color]="def.color">
                <div class="card-body py-1 px-2">
                  <div class="text-uppercase" style="font-size: 0.7rem;">{{ def.label }}</div>
                  <div class="fw-bold mb-0" style="font-size: 1.1rem;">{{ averages[def.key] }}</div>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="text-muted small mb-2">Daily average per source</div>
        <div style="position: relative; height: 350px; width: 100%; overflow: hidden;">
          <c-chart type="line" [data]="transactionsChartData" [options]="transactionsChartOptions" style="position: absolute; inset: 0;"></c-chart>
        </div>
      } @else {
        <div class="text-center text-muted py-4">No data available.</div>
      }
    </div>
  </div>
}
